import { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Document, Page, pdfjs } from "react-pdf";
import { saveAs } from "file-saver";
import { ReactComponent as Upload } from "assets/icons/upload.svg";
import { Button } from "antd";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import Modals from "components/modal";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;
const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const PdfViewer = ({ pdf, modalRef }) => {
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(null);

  const onDocumentComplete = (e) => {
    setPages(e._pdfInfo?.numPages);
  };

  const saveFile = async () => {
    fetch(pdf)
      .then((response) => response.blob())
      .then((blob) => {
        const blobWithOptions = new Blob([blob], {
          type: "application/octet-stream",
        });
        saveAs(blobWithOptions, "rules.pdf");
      })
      .catch((error) => console.error("Error fetching PDF file:", error));
  };

  const onPage = (type) => {
    var newPage = type ? page + 1 : page - 1;

    if (newPage > pages) {
      newPage = 1;
    } else if (newPage < 1) {
      newPage = pages;
    }

    setPage(newPage);
  };

  const footer = (
    <div className="flex justify-between">
      <RightOutlined onClick={() => onPage(0)} />
      <span className="body-14px-medium">
        صفحه {page} از {pages}
      </span>

      <LeftOutlined onClick={() => onPage(1)} />
    </div>
  );

  const title = (
    <Button
      type="link"
      className="text-gray-4 body-14px-medium flex items-center"
      onClick={saveFile}
    >
      <Upload className="ml-1 w-5 h-5" />
      دانلود
    </Button>
  );

  return (
    <Modals
      title={title}
      reference={modalRef}
      footer={footer}
      width="100%"
      className="max-w-md"
    >
      <div className="w-content body-14px-regular">
        <Document
          file={pdf}
          options={options}
          onLoadSuccess={onDocumentComplete}
        >
          <Page pageNumber={page} scale={0.50} />
        </Document>
      </div>
    </Modals>
  );
};
export default PdfViewer;
